export const onClickOutside = (
  selector: string,
  active: string = 'active',
) => {
  document.addEventListener('click', (ev: Event) => {
    const target = ev.target as Element;

    if (!target.closest(selector)) {
      const elements = Array.from(
        document.querySelectorAll(selector),
      );

      elements.forEach((element) => {
        element.classList.remove(active);
      });
    }
  });
};
